// wave4-fix11: the Calendar page mirrors the PHONE (QJ: the iOS calendar screen is the
// reference). NO page title -- "Calendar" lives only in the rail; the page starts directly with
// the tabs, exactly the phone's labels: "Coming up" | "Calendar".
// COMING-UP FIX (2026-07-03, item 2): the top-right "Connect calendar" button here was redundant
// with "Manage my calendars" at the bottom of the Coming Up right rail (ComingUpAgenda) -- both
// routed to the same Settings > Calendars destination. Removed; "Manage my calendars" is the one
// entry point (present in every state, including zero-calendars-connected, per its own rail copy).
import React from "react"

import { useHistory, useLocation } from "react-router-dom"

import "./index.scss"

const VIEWS = [
  { id: "coming-up", label: "Coming up", path: "/coming-up" },
  { id: "calendar", label: "Calendar", path: "/calendar" },
]

const CalendarViewSwitch = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  return (
    <div className="cal-view-switch" data-testid="calendar-view-switch">
      <div className="cal-view-switch__seg">
        {VIEWS.map(v => (
          <button
            key={v.id}
            type="button"
            className={
              "cal-view-switch__btn" +
              (pathname === v.path ? " cal-view-switch__btn--on" : "")
            }
            data-testid={`calendar-view-${v.id}`}
            onClick={() => history.push(v.path)}>
            {v.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CalendarViewSwitch
